import { render } from "./BillsStatusWidget.vue?vue&type=template&id=56b78a80"
import script from "./BillsStatusWidget.vue?vue&type=script&lang=js"
export * from "./BillsStatusWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__